import { Injectable } from "@angular/core";
import { config as CONFIG } from "app/app.config";
import { FuseNavigation } from "@fuse/types";
import {
    RolEncargadoDTO,
    RolRepresentanteDTO,
    Role,
} from "../../interfaces/usuario.interface";
import { UsuarioService } from "../rest/usuario.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

@Injectable({
    providedIn: "root",
})
export class MenuUsuarioService {
    constructor(
        private _usuarioSrvc: UsuarioService,
        private _fuseProgressBarService: FuseProgressBarService
    ) {}

    configuraMenuUsuario(
        navigation: FuseNavigation[],
        roles: Role[] | RolEncargadoDTO[] | RolRepresentanteDTO[]
    ) {
        //console.log(navigation);

        navigation.forEach((nav) => {
            roles.forEach((rol: any) => {
                if (rol.id === CONFIG.roles.encargado.rol) {
                    CONFIG.roles.encargado.permisos.forEach((permiso) => {
                        this.revisaPermisos(nav, permiso);
                    });
                } else if (rol.id === CONFIG.roles.representante.rol) {
                    CONFIG.roles.representante.permisos.forEach((permiso) => {
                        this.revisaPermisos(nav, permiso, roles);
                    });
                } else if (rol.id === CONFIG.roles.supervisor.rol) {
                    CONFIG.roles.supervisor.permisos.forEach((permiso) => {
                        this.revisaPermisos(nav, permiso);
                    });
                }
            });
        });
        //console.log(navigation);
        return navigation;
    }

    revisaPermisos(
        nav: FuseNavigation,
        permiso: any,
        roles: (Role | RolRepresentanteDTO | RolEncargadoDTO)[] = null
    ) {
        if (nav.id === permiso.menu) {
            nav.hidden = false;
            nav.children.forEach((child) => {
                permiso.opciones.forEach((opcion) => {
                    if (child.id === opcion) {
                        child.hidden = false;
                        if (this.esRepresentante() && child.id === "users") {
                            const rolRepresentante = <RolRepresentanteDTO[]>(
                                roles.filter(
                                    (rol) =>
                                        rol.id ===
                                        CONFIG.roles.representante.rol
                                )
                            );
                            let cliente = undefined;
                            if (rolRepresentante.length > 0) {
                                cliente = rolRepresentante[0].cliente.id;
                            }
                            //console.log(rolRepresentante);
                            child.url = `/clientes/${cliente}`;
                        }
                    }
                });
            });
        }
    }

    puedeRealizarAccion(
        idSucursal: number,
        accion:
            | "puedeCotizar"
            | "puedeComprar"
            | "puedeRecibir"
            | "puedeCrearOtros"
    ): boolean {
        const perfilUsuario = this._usuarioSrvc.getPerfil();
        let puedeRealizarAccion = false;
        perfilUsuario.roles.forEach((rol: any) => {
            if (rol.id === CONFIG.roles.encargado.rol) {
                if (rol.sucursal.id === idSucursal) {
                    puedeRealizarAccion = rol.sucursal.permisos[accion];
                }
            } else if (rol.id === CONFIG.roles.supervisor.rol) {
                puedeRealizarAccion = rol[accion];
            }
        });
        return puedeRealizarAccion;
    }

    esSupervisor(): boolean {
        const perfilUsuario = this._usuarioSrvc.getPerfil();
        //console.log("perfilUsuario", perfilUsuario);
        return (
            perfilUsuario.roles.filter(
                (rol: any) => rol.id === CONFIG.roles.supervisor.rol
            ).length > 0
        );
    }
    esRepresentante(): boolean {
        const perfilUsuario = this._usuarioSrvc.getPerfil();

        return (
            perfilUsuario.roles.filter(
                (rol: any) => rol.id === CONFIG.roles.representante.rol
            ).length > 0
        );
    }
    esEncargado(): boolean {
        const perfilUsuario = this._usuarioSrvc.getPerfil();

        return (
            perfilUsuario.roles.filter(
                (rol: any) => rol.id === CONFIG.roles.encargado.rol
            ).length > 0
        );
    }

    async estaAutorizado(allowedRoles: number[]): Promise<boolean> {
        // check if the list of allowed roles is empty, if empty, authorize the user to access the page
        if (allowedRoles == null || allowedRoles.length === 0) {
            return true;
        }
        let perfil = this._usuarioSrvc.getPerfil();
        if (!perfil) {
            this._fuseProgressBarService.show();
            perfil = await this._usuarioSrvc.fetchPerfilPersona();
            //this._usuarioSrvc.setPerfil(perfil);
            this._fuseProgressBarService.hide();
        }
        //console.log(perfil);
        // get token from local storage or state management
        //const token = localStorage.getItem('token');

        // decode token to read the payload details
        //const decodeToken = this.jwtHelperService.decodeToken(token);

        // check if it was decoded successfully, if not the token is not valid, deny access
        //if (!decodeToken) {
        //  console.log('Invalid token');
        //  return false;
        // }
        return (
            perfil.roles.filter((rol) => allowedRoles.indexOf(rol.id) !== -1)
                .length > 0
        );

        //Promise.resolve(true);

        // check if the user roles is in the list of allowed roles, return true if allowed and false if not allowed
        //return allowedRoles.includes(decodeToken['role']);
    }
}
